import React, { useEffect, useMemo, useState } from "react";
import { Card, Form, Table } from "react-bootstrap";
import usePalette from "../../../../hooks/usePalette";
import { useDispatch, useSelector } from "react-redux";
import numeral from "numeral";
import { IconButton, Tooltip } from "@mui/material";
import CurrencyInput from "react-currency-input-field";
import Select, { components } from "react-select";
import { customStylesForm } from "../../../../components/common/customStyleSelect";

// Icons
import Icon from "@mdi/react";
import { mdiPlusCircle, mdiMinusCircle } from "@mdi/js";

import NewProjectScope from "./NewScopeProject";

import {
  // addScopeProject,
  createCertifyFinancial,
  removeScopeProject,
  updateRevisedProjectScope,
} from "../../../../redux/slices/utilsSlice";
import {
  addNewProjectScope,
  deleteNewProjectScope,
  updateNewProjectScope,
} from "../../../../redux/slices/certify/projectsSlice";

const ScopeProject = () => {
  const dispatch = useDispatch();
  const palette = usePalette();

  const { project, revisedProjectScope, projectScopeItems, inputLoading } =
    useSelector((state) => ({
      project: state.certifyReducer.project.data,
      revisedProjectScope: state.utilsReducer.certifyFinancial,
      projectScopeItems: state.utilsReducer.dropdownItems.projectScopeItems,
      inputLoading: state.utilsReducer.inputLoading,
    }));

  const [showNewScopeProjectForm, setShowNewScopeProjectForm] = useState(false);

  const { revisedCost, revisedCeiling } = useMemo(() => {
    const cost = revisedProjectScope?.reduce(
      (acc, obj) => acc + (parseFloat(obj.cost_required) || 0),
      0,
    );

    const ceiling = revisedProjectScope?.reduce(
      (acc, obj) => acc + (parseFloat(obj.ceiling) || 0),
      0,
    );

    return {
      revisedCost: cost,
      revisedCeiling: ceiling,
    };
  }, [revisedProjectScope]);

  const handleNewScopeProject = () => {
    const props = {
      project_id: project.id,
      cost_description: null,
      cost_required: "0.00",
      revised_cost_required: "0.00",
      ceiling: "0.00",
      revised_ceiling: "0.00",
      is_rejected: false,
      ceiling_flow_details: [],
    };
    dispatch(addNewProjectScope(props));
  };

  const handleRemoveScopeProject = async (id) => {
    // dispatch(removeScopeProject(rowIndex));
    const params = {
      id: id,
      project_id: project.id,
    };
    await dispatch(deleteNewProjectScope(params));
  };

  const filteredArray = useMemo(() => {
    if (!revisedProjectScope || !projectScopeItems) return [];

    // Create a Set of all cost_descriptions from revisedProjectScope
    const existingDescriptions = new Set(
      revisedProjectScope.map((item) => item?.cost_description?.toLowerCase()),
    );

    return projectScopeItems.filter(
      (scopeItem) =>
        !existingDescriptions.has(scopeItem.value.toLowerCase()) &&
        !existingDescriptions.has(scopeItem.label.toLowerCase()),
    );
  }, [revisedProjectScope, projectScopeItems]);

  const handleUpdateOnAction = async (props) => {
    const { financial_id, cost_required, ceiling, cost_description } = props;

    const params = {
      id: financial_id,
      project_id: project.id,
      cost_required: cost_required,
      ceiling: ceiling,
      cost_description: cost_description,
    };

    await dispatch(updateNewProjectScope(params));
  };

  useEffect(() => {
    if (project) {
      const newValues = project.financial_details?.map((obj) => {
        return {
          ...obj,
          ceiling_flow_details: obj.ceiling_flow_details.map((subObj) => ({
            ...subObj,
            cost_description: obj.cost_description,
          })),
        };
      });
      dispatch(createCertifyFinancial(newValues));
    }
  }, [dispatch, project]);

  return (
    <>
      <NewProjectScope
        show={showNewScopeProjectForm}
        onHide={() => setShowNewScopeProjectForm(false)}
      />
      <Card>
        {/* Revised Project Scope */}
        <Card.Body>
          <div className='mb-3'>
            <h5>SENARAI SKOP PROJEK DISEMAK</h5>
          </div>
          <div className='table-responsive'>
            <Table bordered size='sm' style={{ fontSize: 11, width: "100%" }}>
              <thead className='text-center align-middle custom-table-head'>
                <tr>
                  <th style={{ width: "5%" }}>BIL.</th>
                  <th style={{ width: "60%" }}>KOMPONEN PROJEK</th>
                  <th style={{ width: "15%" }}>KESELURUHAN KOS DIPOHON (RM)</th>
                  <th style={{ width: "15%" }}>
                    KESELURUHAN SILING DIPOHON (RM)
                  </th>
                  <th style={{ width: "5%" }} />
                </tr>
              </thead>
              <tbody className='text-uppercase' style={{ fontWeight: 500 }}>
                {revisedProjectScope
                  ?.toSorted((a, b) => a.id - b.id)
                  ?.map((obj, idx) => {
                    let costDescription = null;
                    if (obj.cost_description !== null) {
                      costDescription = {
                        label: obj.cost_description,
                        value: obj.cost_description,
                      };
                    }

                    return (
                      <tr key={idx}>
                        <td className='text-center'>{idx + 1}.</td>
                        <td
                          style={{ position: "relative", overflow: "visible" }}
                        >
                          <Select
                            name='cost_description'
                            placeholder='Pilih Skop...'
                            className='react-select-container'
                            classNamePrefix='react-select'
                            isSearchable
                            options={filteredArray}
                            styles={{
                              ...customStylesForm,
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              menu: (provided) => ({
                                ...provided,
                                position: "absolute",
                                width: "100%",
                                minWidth: "100%",
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                whiteSpace: "pre-wrap",
                                wordWrap: "break-word",
                                maxWidth: "100%",
                                overflow: "visible",
                              }),
                              control: (provided) => ({
                                ...provided,
                                minHeight: "auto",
                                alignItems: "flex-start",
                                cursor: inputLoading ? "progress" : "default",
                              }),
                              valueContainer: (provided) => ({
                                ...provided,
                                padding: "8px",
                                flexWrap: "wrap",
                              }),
                              input: (provided) => ({
                                ...provided,
                                padding: 0,
                                margin: 0,
                              }),
                            }}
                            menuPortalTarget={document.body}
                            menuPosition='absolute'
                            menuPlacement='auto'
                            value={costDescription}
                            onChange={(value) => {
                              const newValues = {
                                id: obj.id,
                                value: value,
                                type: "scope",
                              };
                              dispatch(updateRevisedProjectScope(newValues));
                            }}
                            noOptionsMessage={() => "Tiada pilihan"}
                            components={{
                              SingleValue: ({ children, ...props }) => (
                                <components.SingleValue {...props}>
                                  <div
                                    style={{
                                      whiteSpace: "pre-wrap",
                                      wordBreak: "break-word",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {children}
                                  </div>
                                </components.SingleValue>
                              ),
                            }}
                            onBlur={async () => {
                              const props = {
                                financial_id: obj.id,
                                cost_required: obj.cost_required,
                                ceiling: obj.ceiling,
                                cost_description: costDescription.value || null,
                              };
                              handleUpdateOnAction(props);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                const props = {
                                  financial_id: obj.id,
                                  cost_required: obj.cost_required,
                                  ceiling: obj.ceiling,
                                  cost_description:
                                    costDescription.value || null,
                                };
                                handleUpdateOnAction(props);
                              }
                              return;
                            }}
                          />
                        </td>
                        <td className='text-end pe-2'>
                          <Form.Group className='w-100'>
                            <Form.Control
                              className={`text-end text-truncate`}
                              as={CurrencyInput}
                              min={0}
                              name='amount'
                              autoComplete='off'
                              decimalScale={2}
                              decimalsLimit={2}
                              value={obj.cost_required}
                              onValueChange={(value) => {
                                let newValue = value;

                                if (
                                  parseFloat(value) < parseFloat(obj.ceiling)
                                ) {
                                  return;
                                }

                                const newValues = {
                                  id: obj.id,
                                  value: newValue || obj.ceiling,
                                  type: "cost",
                                };
                                dispatch(updateRevisedProjectScope(newValues));
                              }}
                              onBlur={async () => {
                                let newValue = obj.cost_required;

                                if (
                                  parseFloat(obj.cost_required) <
                                  parseFloat(obj.ceiling)
                                ) {
                                  return;
                                }
                                const props = {
                                  financial_id: obj.id,
                                  cost_required: newValue || obj.ceiling,
                                  ceiling: obj.ceiling,
                                  cost_description: obj.cost_description,
                                };
                                handleUpdateOnAction(props);
                              }}
                              disabled={inputLoading}
                              style={{
                                cursor: inputLoading ? "progress" : "default",
                              }}
                            />
                            <Form.Control.Feedback type='invalid'>
                              Kos tidak boleh kurang dari siling
                            </Form.Control.Feedback>
                          </Form.Group>
                        </td>
                        <td className='text-end pe-2'>
                          <Form.Group className='w-100'>
                            <Form.Control
                              className={`text-end text-truncate`}
                              as={CurrencyInput}
                              min={0}
                              name='amount'
                              autoComplete='off'
                              decimalScale={2}
                              decimalsLimit={2}
                              value={obj.ceiling}
                              onValueChange={(value) => {
                                const newValues = {
                                  id: obj.id,
                                  value: value || "0.00",
                                  type: "ceiling",
                                };
                                dispatch(updateRevisedProjectScope(newValues));
                              }}
                              onBlur={async () => {
                                const props = {
                                  financial_id: obj.id,
                                  cost_required: obj.cost_required,
                                  ceiling: obj.ceiling,
                                  cost_description: obj.cost_description,
                                };
                                handleUpdateOnAction(props);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  const props = {
                                    financial_id: obj.id,
                                    cost_required: obj.cost_required,
                                    ceiling: obj.ceiling,
                                    cost_description: obj.cost_description,
                                  };
                                  handleUpdateOnAction(props);
                                }
                                return;
                              }}
                              disabled={inputLoading}
                              // isInvalid={errors.some(
                              //   (item) => item === component.id,
                              // )}
                              style={{
                                cursor: inputLoading ? "progress" : "default",
                              }}
                            />
                            {/* <Form.Control.Feedback type='invalid'>
                              Kos tidak boleh kurang dari siling
                            </Form.Control.Feedback> */}
                          </Form.Group>
                        </td>
                        <td className='text-center'>
                          <Tooltip
                            title='Tambah Skop'
                            placement='top'
                            followCursor
                            arrow
                            className='p-0'
                          >
                            <IconButton
                              className='button-animated position-relative'
                              style={{ backgroundColor: "transparent" }}
                              onClick={() => handleRemoveScopeProject(obj.id)}
                            >
                              <Icon
                                className=''
                                path={mdiMinusCircle}
                                size={0.8}
                                color={palette.danger}
                                disabled={inputLoading}
                              />
                            </IconButton>
                          </Tooltip>
                        </td>
                      </tr>
                    );
                  })}
                <tr>
                  <td colSpan={2} className='text-center border-end-0'>
                    <Tooltip
                      title='Tambah Skop'
                      placement='top'
                      followCursor
                      arrow
                      className='p-0'
                    >
                      <IconButton
                        className='button-animated position-relative'
                        style={{ backgroundColor: "transparent" }}
                        onClick={handleNewScopeProject}
                        disabled={inputLoading}
                      >
                        <Icon
                          className=''
                          path={mdiPlusCircle}
                          size={1}
                          color={palette.primary}
                        />
                      </IconButton>
                    </Tooltip>
                  </td>
                  <td colSpan={3} className='text-center border-start-0' />
                </tr>
                <tr>
                  <td colSpan={2} className='text-end pe-2'>
                    JUMLAH KESELURUHAN{" "}
                    <span className='fw-bolder'>(DISEMAK)</span>
                  </td>
                  <td className='text-end pe-2 fw-bolder'>
                    {numeral(revisedCost).format("0,0.00")}
                  </td>
                  <td className='text-end pe-2 fw-bolder'>
                    {numeral(revisedCeiling).format("0,0.00")}
                  </td>
                  <td />
                </tr>
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default ScopeProject;
